module.exports = __webpack_public_path__ + "img/no-result2.1a24e76d.png";